import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TimesheetCalendarSourceType } from 'api/timesheets';
import { ReactComponent as AtomGCalLogo } from 'assets/svgs/google-calendar.svg';
import { ReactComponent as AtomOutlookCal } from 'assets/svgs/outlook.svg';
import { GoogleLogin, MicrosoftLogin } from 'components/atoms/vendor-loign';
import {
  DrawerBody,
  EmptyState,
} from 'components/organisms/timesheets/drawers/calendar-integration/component';
import { useTimesheetIntegrationOauthQuery } from 'queries/timesheets/calendar-integration-provider';

interface Props {
  sourceType: TimesheetCalendarSourceType;
}
const GCalLogo = styled(AtomGCalLogo)`
  width: 60px;
  height: 60px;
`;
const OutlookCal = styled(AtomOutlookCal)`
  width: 60px;
  height: 60px;
`;

export const SetupCalendar: FC<Props> = ({ sourceType }) => {
  const frontendRedirectPath = window.location.pathname;
  const { data: authMeta, isLoading } = useTimesheetIntegrationOauthQuery(
    sourceType,
    frontendRedirectPath,
  );
  const googleOAuth = authMeta?.oauthUrl;

  const isGcal = sourceType === TimesheetCalendarSourceType.GoogleCalendar;
  const LoginButton = isGcal ? GoogleLogin : MicrosoftLogin;

  return (
    <DrawerBody>
      <EmptyState
        image={isGcal ? <GCalLogo /> : <OutlookCal />}
        title={<FormattedMessage id="ai_fill.calendar_connect.title" />}
        message={
          isGcal ? (
            <FormattedMessage id="ai_fill.project_updates.calendar_connect.google.description" />
          ) : (
            <FormattedMessage id="ai_fill.project_updates.calendar_connect.outlook.description" />
          )
        }
        primaryCTA={<LoginButton href={googleOAuth!} isLoading={isLoading} />}
      />
    </DrawerBody>
  );
};
